<div class="left-column">
	<div class="header">
		<img class="img" src="/assets/img/dropbox-sign-logo.png" />
		<span class="title">Signatures Dashboard</span>
	</div>

	<div class="title-text" *ngIf="!error && !loadingProcoreDetails && !loadingProjects && (!loadingSignatures || initialResultsLoaded)">Account Details:</div>
	<div class="details" *ngIf="!error && !loadingProcoreDetails && !loadingProjects && (!loadingSignatures || initialResultsLoaded)">
		<div class="title">TERM END DATE:</div>
		<div class="subtitle">{{ clientDetailProcore?.licenseExpirationDate | date:'MM/dd/yyyy' }}</div>
		<!-- <div class="title">PROCORE REQUESTS SENT:</div>
		<div class="subtitle">{{ liveSignaturesCount }}</div>
		<div class="title">TEST SIGNATURES SENT:</div>
		<div class="subtitle">{{ testSignaturesCount }}</div> -->
	</div>

	<div class="title-text" *ngIf="!error && !loadingProcoreDetails && !loadingProjects && (!loadingSignatures || initialResultsLoaded)">Filters:</div>
	<div class="filters" *ngIf="!error && !loadingProcoreDetails && !loadingProjects && (!loadingSignatures || initialResultsLoaded)">
		<div class="selected" (click)="showStatusSelector = !showStatusSelector">STATUS: {{ filterStatus }}</div>
		<div class="selector" *ngIf="showStatusSelector">
			<div (click)="filterStatus = 'ALL'; showStatusSelector = false;">ALL</div>
			<div (click)="filterStatus = 'CANCELLED'; showStatusSelector = false;">CANCELLED</div>
			<div (click)="filterStatus = 'COMPLETED'; showStatusSelector = false;">COMPLETED</div>
			<div (click)="filterStatus = 'DECLINED'; showStatusSelector = false;">DECLINED</div>
			<div (click)="filterStatus = 'DELETED'; showStatusSelector = false;">DELETED</div>
			<div (click)="filterStatus = 'REQUESTED'; showStatusSelector = false;">REQUESTED</div>
		</div>

		<div class="selected" (click)="showProjectSelector = !showProjectSelector">
			<ng-container *ngIf="filterProject == 'ALL'">PROJECT: ALL</ng-container>
			<ng-container *ngIf="filterProject !== 'ALL'"><span [title]="filterProjectName">PROJECT: {{ filterProjectName }}</span></ng-container>
		</div>
		<div class="selector" *ngIf="showProjectSelector">
			<div (click)="filterProject = 'ALL'; filterProjectName = ''; showProjectSelector = false;">ALL</div>
			<div *ngFor="let project of projects" (click)="filterProject = project.id; filterProjectName = project.name; showProjectSelector = false;" [title]="project.name">{{ project.name }}</div>
		</div>

		<div class="selected" (click)="showModeSelector = !showModeSelector">
			<ng-container *ngIf="filterMode == 'ALL'">MODE: ALL</ng-container>
			<ng-container *ngIf="filterMode == 'LIVE'">MODE: LIVE</ng-container>
			<ng-container *ngIf="filterMode == 'TEST'">MODE: TEST</ng-container>
		</div>
		<div class="selector" *ngIf="showModeSelector">
			<div (click)="filterMode = 'ALL'; showModeSelector = false;">ALL</div>
			<div (click)="filterMode = 'LIVE'; showModeSelector = false;">LIVE</div>
			<div (click)="filterMode = 'TEST'; showModeSelector = false;">TEST</div>
		</div>

		<button [disabled]="loadingSendMassReminders || loadingSendReminderIds.length > 0 || loadingDownloadIds.length > 0" class="reminder-button" (click)="reloadSignatures()">UPDATE RESULTS <i class="fas fa-search"></i></button>
	</div>

	<div class="title-text" *ngIf="!error && !loadingProcoreDetails && !loadingProjects && (!loadingSignatures || initialResultsLoaded)">Actions:</div>
	<div class="actions" *ngIf="!error && !loadingProcoreDetails && !loadingProjects && (!loadingSignatures || initialResultsLoaded)">
		<button [disabled]="!showSendReminderButton || loadingSendMassReminders || loadingSendReminderIds.length > 0 || loadingDownloadIds.length > 0" class="reminder-button" (click)="sendMassReminders()">SEND MASS-REMINDERS <i class="fas fa-bell"></i></button>
	</div>

</div>
<div class="right-column">
	<div class="inner">
		<div *ngIf="!error && (loadingProcoreDetails || loadingProjects || (loadingSignatures && !initialResultsLoaded))" class="loading-container">
			<div class="lds-facebook">
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>

		<div *ngIf="error" class="error-container">
			<div>For security reasons, your session has expired.</div>
			<div>To re-load this data, close this window and launch the dashboard from the Procore side-panel.</div>
		</div>

		<div *ngIf="!error && !loadingProcoreDetails && !loadingProjects && !loadingSignatures && signatures.length == 0" class="error-container">No signatures exist.</div>

		<div class="data" *ngIf="!error && (!loadingSignatures || initialResultsLoaded) && signatures.length > 0">
			<div class="table-wrapper">
				<table class="signatures">
					<tr>
						<th class="center">Actions</th>
						<th class="center id">Dropbox Sign Request ID</th>
						<th class="center">Procore Context</th>
						<th class="center">Status</th>
						<th class="center sort" (click)="setSortBy('signatureRequestDate')">Requested <span class="sort-cell" *ngIf="!loadingSignatures"><i class="fas fa-sort-up" [ngClass]="{'disabled': sortBy !== 'signatureRequestDate' || sortOrder !== 'asc'}"></i><i class="fas fa-sort-down" [ngClass]="{'disabled': sortBy !== 'signatureRequestDate' || sortOrder !== 'desc'}"></i></span></th>
						<th class="center sort" (click)="setSortBy('signatureCompleteDate')">Completed <span class="sort-cell" *ngIf="!loadingSignatures"><i class="fas fa-sort-up" [ngClass]="{'disabled': sortBy !== 'signatureCompleteDate' || sortOrder !== 'asc'}"></i><i class="fas fa-sort-down" [ngClass]="{'disabled': sortBy !== 'signatureCompleteDate' || sortOrder !== 'desc'}"></i></span></th>
						<th>Filename</th>
						<th>Project</th>
						<th>Requested By</th>
						<th class="center">Mode</th>
					</tr>
					<ng-container *ngFor="let signature of signatures">
						<tr [ngClass]="signature.status" [class.production]="signature.isProductionMode">
							<td class="actions-cell">
								<i *ngIf="checkSuccessSenderReminder(signature.signatureRequestId)" class="fas fa-check" title="A reminder has been sent"></i>
								<i *ngIf="checkErrorSenderReminder404(signature.signatureRequestId)" class="fas fa-times" title="The request no longer exists in Dropbox Sign"></i>
								<i *ngIf="checkErrorSenderReminder410(signature.signatureRequestId)" class="fas fa-times" title="A reminder can only be sent once per hour"></i>
								<ng-container *ngIf="!checkErrorSenderReminder404(signature.signatureRequestId) && !checkErrorSenderReminder410(signature.signatureRequestId) && !checkSuccessSenderReminder(signature.signatureRequestId)">
									<i *ngIf="checkLoadingSenderReminder(signature.signatureRequestId)" class="fas fa-spinner fa-spin"></i>
									<i *ngIf="signature.status == 'REQUESTED' && !checkLoadingSenderReminder(signature.signatureRequestId) && loadingSendReminderIds.length == 0 && loadingDownloadIds.length == 0 && !loadingSendMassReminders" class="fas fa-bell" title="Send reminder" (click)="sendReminder(signature)"></i>
									<div *ngIf="(signature.status !== 'REQUESTED' && !checkLoadingSenderReminder(signature.signatureRequestId)) || loadingDownloadIds.length > 0" class="blank-icon"></div>
								</ng-container>

								<i *ngIf="checkErrorDownload(signature.signatureRequestId)" class="fas fa-times" title="Cannot download the file from Dropbox Sign"></i>
								<ng-container *ngIf="!checkErrorDownload(signature.signatureRequestId)">
									<i *ngIf="checkLoadingDownload(signature.signatureRequestId)" class="fas fa-spinner fa-spin"></i>
									<i *ngIf="signature.status == 'COMPLETED' && !checkLoadingDownload(signature.signatureRequestId) && loadingSendReminderIds.length == 0 && !loadingSendMassReminders" class="fas fa-download" title="Download" (click)="downloadRequest(signature.signatureRequestId, signature.filename)"></i>
									<div *ngIf="(signature.status !== 'COMPLETED' && !checkLoadingDownload(signature.signatureRequestId)) || loadingSendReminderIds.length > 0" class="blank-icon"></div>
								</ng-container>
							</td>
							<td class="id"><span [title]="signature.signatureRequestId">{{ signature.signatureRequestId }}</span></td>
							<td>{{ signature.context }}</td>
							<td class="center"><span class="status-container" [ngClass]="signature.status">{{ signature.status }}</span></td>
							<td class="center">{{ signature.signatureRequestDate | date:'MM/dd/yyyy' }}</td>
							<td class="center"><ng-container *ngIf="signature.status == 'COMPLETED'">{{ signature.signatureCompleteDate | date:'MM/dd/yyyy' }}</ng-container></td>
							<td>{{ signature.filename }}</td>
							<td class="projects-cell">{{ signature.projectName }}</td>
							<td class="requested-cell">{{ signature.requestedUser }}</td>
							<td class="center">
								<span *ngIf="signature.isProductionMode" class="live-container">LIVE</span>
								<span *ngIf="!signature.isProductionMode" class="test-container">TEST</span>
							</td>
						</tr>
					</ng-container>
				</table>
			</div>

			<div class="count-message">Showing {{ signatures.length }} of {{ signaturesCount }} requests</div>
			<div class="count-message" *ngIf="!loadingSendMassReminders &&  loadingSendReminderIds.length == 0 && loadingDownloadIds.length == 0 && !loadingSignatures && signatures.length < signaturesCount"><a (click)="getDashboardSignatures()">Load more results...</a></div>
			<div class="count-message" *ngIf="loadingSignatures && initialResultsLoaded"><i class="fas fa-spinner fa-spin"></i></div>
		</div>
	</div>
</div>